module.exports = __webpack_public_path__ + "static/img/popover_iconh5_04_zh.118a755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popover_iconh5_04_zh.png
// module id = PWHG
// module chunks = 34